<div class="legal-person-form" *ngIf="personType === 'JURIDICA'">
    <div class="form-line">
        <mat-form-field class="garantor-form-field cuit" appearance="outline">
            <mat-label>CUIT</mat-label>
            <app-cuit-input [formControl]="formGroup.controls.cuit"></app-cuit-input>
            <mat-error *ngIf="formGroup.controls.cuit.hasError('required')">
                Por favor ingrese un cuit
            </mat-error>
            <mat-error *ngIf="formGroup.controls.cuit.hasError('minlength') || formGroup.controls.cuit.hasError('maxlength')">
                El cuit debe tener 11 dígitos
            </mat-error>
            <mat-error *ngIf="formGroup.controls.cuit.hasError('number')">
                El cuit debe ser un número
            </mat-error>
        </mat-form-field>
        <mat-form-field class="garantor-form-field razon-social" appearance="outline">
            <mat-label>Razón social</mat-label>
            <input matInput [formControl]="formGroup.controls.razonSocial">
            <mat-error *ngIf="formGroup.controls.razonSocial.hasError('required')">
                Por favor ingrese una razón social
            </mat-error>
        </mat-form-field>
    </div>
    <ng-content></ng-content>
    <div class="flex-wrap-line">
        <mat-form-field class="garantor-form-field telefono" appearance="outline">
            <mat-label>Teléfono</mat-label>
            <app-phone-input [formControl]="formGroup.controls.celular"></app-phone-input>
            <mat-error *ngIf="formGroup.controls.celular.hasError('required')">
                Por favor ingrese un teléfono
            </mat-error>
            <mat-hint>Ejemplo: + 54 - 911 - 11112222</mat-hint>
        </mat-form-field>
        <mat-form-field class="garantor-form-field rubro" appearance="outline">
            <mat-label>Rubro</mat-label>
            <mat-select [formControl]="formGroup.controls.rubro" [compareWith]="utilsService.compareSelectOption">
                <mat-option *ngFor="let heading of headings" [value]="heading" [attr.name]="heading.codigo">
                    {{ heading.descripcion }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup.controls.rubro.hasError('required')">
                Por favor seleccione el rubro
            </mat-error>
        </mat-form-field>
        <mat-form-field class="garantor-form-field rubro-custom" appearance="outline" *ngIf="formGroup.controls.rubro.value && formGroup.controls.rubro.value.codigo === '-1'">
            <mat-label>Ingrese el rubro</mat-label>
            <input matInput [formControl]="formGroup.controls.rubroPersonalizado">
        </mat-form-field>
        <mat-form-field class="garantor-form-field situacion-iva" appearance="outline">
            <mat-label>Situación frente al IVA</mat-label>
            <mat-select [formControl]="formGroup.controls.situacionIVA" [compareWith]="utilsService.compareSelectOption">
                <mat-option *ngFor="let ivaSituation of ivaSituations" [value]="ivaSituation" [attr.name]="ivaSituation.codigo">
                    {{ ivaSituation.descripcion }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup.controls.situacionIVA.hasError('required')">
                Por favor seleccione su situación
            </mat-error>
        </mat-form-field>
        <mat-form-field class="garantor-form-field tipo-sociedad" appearance="outline">
            <mat-label>Tipo de sociedad</mat-label>
            <mat-select [formControl]="formGroup.controls.tipoSociedad">
                <mat-option *ngFor="let societyType of societyTypes" [value]="societyType.codigo" [attr.name]="societyType.codigo">
                    {{ societyType.descripcion }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup.controls.tipoSociedad.hasError('required')">
                Por favor seleccione el tipo de sociedad
            </mat-error>
        </mat-form-field>
        <mat-form-field class="garantor-form-field tipo-sociedad-custom" appearance="outline" *ngIf="formGroup.controls.tipoSociedad.value === 'OTRO'">
            <mat-label>Ingrese el tipo de sociedad</mat-label>
            <input matInput [formControl]="formGroup.controls.tipoSociedadPersonalizado">
        </mat-form-field>
    </div>
</div>
